import React from 'react';
import ShopItem from "./shopItem";
import {ShopLoader} from "./placeholders";

const ShopList = ({shopsQueryState}) =>
{
    const data = !!shopsQueryState.data && shopsQueryState.data.length > 1 ? shopsQueryState.data.slice(0, 2) : shopsQueryState.data;
    return (
        <ul className="slides">
            { (!shopsQueryState.isLoading && !shopsQueryState.isFetching && !shopsQueryState.data) && <>Aucun magasin à proximité</> }
            { (shopsQueryState.isLoading || shopsQueryState.isFetching || !shopsQueryState.data) && <ShopLoader />}
            { shopsQueryState?.data?.length > 0 && data.map((item, index)=> <ShopItem key={`shop-item-${index}`} item={item} /> ) }
        </ul>
    );
}

export default ShopList;